import BannertextprimaryCommon from './containers/bannertextprimaryCommon'

export {default as BannertextprimaryCommonLayout} from './components/bannertextprimaryCommonLayout'

export default BannertextprimaryCommon
